<template>
  <summary-detail :name="artistName" type="红人" :year="year">
    <div>
      <platform-count :year="year" :artist-id="this.artistId" :organization-id="organization_id"/>
      <br/>
      <platform-money :year="year" :artist-id="this.artistId" :organization-id="organization_id"/>
      <br/>
      <customer-per-price :year="year" :artist-id="this.artistId" :organization-id="organization_id"/>
      <br/>
      <artist-brand :year="year" :artist-id="this.artistId" :organization-id="organization_id"/>
    </div>
  </summary-detail>
</template>

<script>
import customerPerPrice from "@/components/summary/detail/customerPerPrice";
import ArtistBrand from "@/components/summary/artistDetail/brand";
import SummaryDetail from "@/views/dashboard/components/Detail.vue";
import PlatformCount from "@/components/summary/detail/platformCount.vue";
import PlatformMoney from "@/components/summary/detail/platformMoney.vue";

export default {
  name: "SummaryArtistDetail",
  components: {PlatformMoney, PlatformCount, SummaryDetail, customerPerPrice, ArtistBrand},
  data() {
    return {
      artistName: this.$route.query.artistName,
      artistId: this.$route.query.artistId,
      year: this.$route.query.year,
      organization_id: this.$route.query.organization_id || 'ALL',
    }
  },
}
</script>

<style>

</style>
